

exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

function $guestThrottle(flowName, token, lang, country, mfid) {

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country,
            mfid: mfid
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function isGuestFlowEnabled() {
        return _angular.$q.resolve(true);
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$q;

_logger.$logger;

_squid.$dispatch;

_squid.$FallbackError;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/guestThrottle.js
// module id = ./pages/xo-login/guestThrottle.js
// module chunks = main-code-split